<template>
  <div :class="{ transparent: this.mode == 'transparent' }">
    <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
      <div class="logo">
        <router-link to="/home"
          ><img
            v-if="hostName.indexOf('diamond-up.com') != -1"
            src="@/assets/img/logo_du.png"
            alt="" /><img
            class="logo2"
            v-else
            src="@/assets/img/logo.png"
            alt=""
        /></router-link>
      </div>

      <div class="funcRight">
        <a-input
          v-if="this.mode != 'transparent'"
          style="margin-right: 20px"
          @pressEnter="doTrack"
          @change="changeTrackNo"
          v-model="trackNo"
        >
          <a-icon slot="suffix" type="search" />
          <a-select
            v-model="trackType"
            slot="addonBefore"
            style="width: 120px"
            @change="changeTrackType"
          >
            <a-select-option value="0">{{
              $t("search.type.0")
            }}</a-select-option>
            <a-select-option value="1">{{
              $t("search.type.1")
            }}</a-select-option>
            <a-select-option value="2">{{
              $t("search.type.2")
            }}</a-select-option>
            <a-select-option value="3">{{
              $t("search.type.3")
            }}</a-select-option>
          </a-select>
        </a-input>
        <a-popover>
          <template slot="content">
            <a-button type="link" @click="changeLocale('en')">English</a-button
            ><br />
            <a-button type="link" @click="changeLocale('zh-cn')"
              >简体中文</a-button
            >
          </template>
          <i class="iconfont tlicon-global" />
        </a-popover>

        <a-divider type="vertical" />

        <div v-if="!userName" style="display:flex;">
          <a-button type="link" @click="toLogin">
            {{ $t("login.title") }}
          </a-button>

          <a-button type="link" @click="toRegister">
            {{ $t("register.title") }}
          </a-button>
        </div>
        <a-dropdown-button v-else @click="onClickButton">
          <span>{{ $t("system.hello", [userName]) }}</span>

          <a-menu slot="overlay" @click="onClickDropdown">
            <a-menu-item key="1">
              <span>{{ $t("system.enter") }}</span></a-menu-item
            >
            <a-menu-item key="2">
              <span>{{ $t("login.logout") }}</span></a-menu-item
            >
          </a-menu>
          <a-icon slot="icon" type="user" />
        </a-dropdown-button>
      </div>

      <a-menu
        theme="dark"
        mode="horizontal"
        :selectable="false"
        @click="onClickMenu"
      >
        <a-menu-item :key="1">
          {{ $t(`menu.home`) }}
        </a-menu-item>
        <a-menu-item :key="2"
          ><a-popover overlayClassName="customPopup">
            <template slot="content">
              <div class="popContent">
                <a-row>
                  <a-collapse accordion defaultActiveKey="1">
                    <a-collapse-panel key="1" :showArrow="false">
                      <template slot="header">
                        <i class="iconfont tlicon-ship--line" />
                        <span>{{ $t("product.ship.title") }}</span>
                      </template>
                      <a-row type="flex" justify="space-between">
                        <a-button
                          class="item"
                          type="link"
                          @click="toDetail('ship_zmhyzx')"
                          >{{ $t("product.ship.products.0") }}</a-button
                        >
                        <a-button
                          class="item"
                          type="link"
                          @click="toDetail('ship_zmhypx')"
                          >{{ $t("product.ship.products.1") }}</a-button
                        >
                      </a-row>
                      <a-row
                        type="flex"
                        justify="start"
                        v-if="hostName.indexOf('diamond-up.com') != -1"
                      >
                        <a-button
                          class="item"
                          type="link"
                          @click="toDetail('ship_hwc')"
                          >{{ $t("product.ship.products.2") }}</a-button
                        >
                      </a-row>
                    </a-collapse-panel>
                    <a-collapse-panel key="2" :showArrow="false">
                      <template slot="header">
                        <i class="iconfont tlicon-plane-fly" />
                        <span>{{ $t("product.plane.title") }}</span>
                      </template>
                      <a-row type="flex" justify="space-between">
                        <a-button
                          class="item"
                          type="link"
                          @click="toDetail('plane_zmkyzx')"
                          >{{ $t("product.plane.products.0") }}</a-button
                        >
                        <a-button
                          class="item"
                          type="link"
                          @click="toDetail('plane_zokyzx')"
                          >{{ $t("product.plane.products.1") }}</a-button
                        >
                      </a-row>
                    </a-collapse-panel>
                    <a-collapse-panel key="3" :showArrow="false">
                      <template slot="header">
                        <i class="iconfont tlicon-truck" />
                        <span>{{ $t("product.truck.title") }}</span>
                      </template>
                      <a-row type="flex" justify="space-between">
                        <a-button
                          class="item"
                          type="link"
                          @click="toDetail('truck_zokyzx')"
                          >{{ $t("product.truck.products.0") }}</a-button
                        >
                      </a-row>
                    </a-collapse-panel>
                  </a-collapse>
                </a-row>
              </div>
            </template>
            {{ $t(`menu.product`) }}
          </a-popover></a-menu-item
        >
        <a-menu-item :key="3">
          <a-popover overlayClassName="customPopup">
            <template slot="content">
              <div class="popContent">
                <a-row type="flex" justify="space-around">
                  <div class="service_menu" @click="toSearch">
                    <i class="iconfont tlicon-wenjian" />{{
                      $t("search.title")
                    }}
                  </div>
                  <div
                    v-if="hostName.indexOf('diamond-up.com') != -1"
                    class="service_menu"
                  >
                    <i class="iconfont tlicon-jisuanqi" />{{
                      $t("calc.title2")
                    }}
                  </div>
                  <div v-else class="service_menu" @click="toTrial">
                    <i class="iconfont tlicon-jisuanqi" />{{ $t("calc.title") }}
                  </div>
                </a-row>
                <a-row
                  type="flex"
                  justify="end"
                  v-if="hostName.indexOf('diamond-up.com') != -1"
                >
                  <a-col :span="12" :offset="12">
                    <div class="service_image">
                      <img src="@/assets/img/yjzx.png" alt="" />
                    </div>
                  </a-col>
                </a-row>
              </div>
            </template>
            {{ $t(`menu.service`) }}
          </a-popover>
        </a-menu-item>
        <a-menu-item :key="4">
          {{ $t(`menu.about`) }}
        </a-menu-item>
        <!-- <a-menu-item v-for="item in menuList" :key="item.id">
        {{ $t(`menu.${item.code}`) }}
      </a-menu-item> -->
      </a-menu>
    </a-layout-header>
  </div>
</template>
<script>
import mainServer from "@/api/index";
import { mapMutations } from "vuex";
export default {
  props: ["mode"],
  data() {
    return {
      headerMode: "",
      routes: {
        1: "/home",
        2: null,
        3: null,
        4: "/about",
      },
      trackType: "0",
      trackNo: "",
      userName: localStorage.getItem("ms_username"),
    };
  },
  computed: {
    menuList() {
      return this.$store.state.system.menuList;
    },

    loginMenuList() {
      let fullMenuList = this.$store.state.system.loginMenuList;
      let permissions = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).permissions
        : [];
      if (!permissions) {
        permissions = [];
      }
      return fullMenuList.filter(
        (item) => permissions.indexOf(item.permission) >= 0
      );
    },
    hostName() {
      return location.hostname.toLowerCase();
    },
  },
  created() {
    // console.log(this.mode)
  },
  methods: {
    ...mapMutations(["setTrackNo", "setTrackType"]),
    changeTrackType(val) {
      console.log(val);
      this.setTrackType(val);
    },
    changeTrackNo(e) {
      this.setTrackNo(e.target.value);
    },
    doTrack() {
      if (this.trackNo.trim() == "") return;
      this.$router.push({
        path: "/search",
        query: { no: this.trackNo },
      });
    },
    onClickMenu(item) {
      const route = this.routes[item.key];
      route && this.$router.push(route);
    },
    toLogin() {
      this.$router.push("/login");
    },
    toRegister() {
      this.$router.push("/register");
    },
    toDetail(code) {
      this.$router.push({
        path: "/productInfo",
        query: { type: code },
      });
    },
    toSearch() {
      this.$router.push("/search");
    },

    toTrial() {
      return;
      this.$router.push("/trial");
    },

    onClickButton() {
      this.onClickDropdown({ key: 1 });
    },

    onClickDropdown(e) {
      if (e.key == 1) {
        if (this.loginMenuList.length > 0) {
          this.$router.push(`/${this.loginMenuList[0].code}`);
          //  this.$router.push(`/dashboard`);
        } else {
          this.$message.warning(this.$t("login.noAuth"));
        }
      } else if (e.key == 2) {
        mainServer
          .logout({})
          .then(() => {
            localStorage.removeItem("ms_username");
            localStorage.removeItem("access_token");
            localStorage.removeItem("user");
            this.userName = null;
          })
          .catch(() => {
            localStorage.removeItem("ms_username");
            localStorage.removeItem("access_token");
            localStorage.removeItem("user");
            this.userName = null;
          });
      }
    },
    changeLocale(language) {
      this.$i18n.locale = language;
      this.$store.commit("setLanguage", language);
      localStorage.setItem("locale", language);
      location.reload();
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.logo {
  width: 120px;
  height: 31px;

  float: left;

  img {
    width: 120px;
    height: 30px;
  }

  .logo2 {
    width: 120px;
    height: 22px;
  }
}

.funcRight {
  float: right;
  display: flex;
  align-items: center;
  height: 64px;
  /deep/ .ant-btn-link {
    color: #ffffff;
    opacity: 0.65;
  }
  /deep/ .ant-btn-link:hover {
    opacity: 1;
  }
  /deep/ .ant-divider-vertical {
    height: 20px;
    opacity: 0.65;
    margin-right: 15px;
  }
  .iconfont {
    font-size: 18px;
    color: white;
    margin: 0 10px;
    cursor: pointer;
    opacity: 0.65;
  }
  .iconfont:hover {
    opacity: 1;
  }
}
/deep/.ant-menu {
  font-size: 16px;
  .ant-menu-item {
    line-height: 64px;
  }
}

.popContent {
  width: 630px;
  opacity: 0.95;
  padding: 30px;
  min-height: 300px;

  .iconfont {
    font-size: 30px;
    color: #7fd8c0;
  }

  /deep/ .ant-collapse {
    border: none;

    .ant-collapse-item {
      border: none;
      background: white;
      .ant-collapse-header {
        border-bottom: 4px solid #e6e6e6;
        background-color: white;
        width: 200px;
        span {
          font-size: 24px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin-left: 35px;
        }
      }
      .ant-collapse-content {
        border: none;
      }
      .ant-collapse-content-box {
        .item {
          font-size: 22px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          margin: 30px 40px;
        }
        .item:hover {
          color: red;
        }
      }
    }
  }

  .service_menu {
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    min-width: 220px;
    border-bottom: 3px solid #e6e6e6;
    display: flex;
    align-items: center;
    padding-bottom: 5px;

    .iconfont {
      margin-left: 10px;
      margin-right: 20px;
    }
  }

  .service_image {
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }

  .service_menu:hover {
    cursor: pointer;
    color: red;
  }
}

.transparent {
  /deep/ .ant-layout-header {
    background-color: transparent;
  }
  /deep/ .ant-menu {
    background-color: transparent;
  }
}

/deep/ .ant-btn-default {
  background-color: transparent;
  color: white;
  font-size: 16px;
  border: none;
  &:hover {
    background-color: transparent;
    color: white;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue